document.addEventListener('DOMContentLoaded',function(){
  if(document.body.dataset.animations==='true'){
    var o=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting)x.target.classList.add('vis')})},{threshold:.04});
    document.querySelectorAll('.reveal').forEach(function(el){o.observe(el)});
  }else{
    document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('vis')});
  }
  var n=document.getElementById('site-nav');
  if(n)window.addEventListener('scroll',function(){n.classList.toggle('s',scrollY>50)},{passive:true});
});

// FAQ already handled by inline onclick
